<template>
  <div class="subjectDetails">
    <div class="topTitle">
      <span @click="goback">返回</span> / {{ this.$route.query.title }}
    </div>
    <div class="main">
      <el-tabs v-model="activeName">
        <el-tab-pane label="题单简介" name="first">
          <el-row :gutter="20">
            <el-col :span="16">
              <div v-html="$route.query.description"></div>
            </el-col>
            <el-col :span="8">
              <div class="briefIntroduction_right">
                <ul>

                  <li class="clearfix">
                    <div class="fl">创建者</div>
                    <div class="fr" v-if="$route.query.realname != null">{{ $route.query.realname }}</div>
                    <div class="fr" v-else>格小C</div>

                  </li>
                  <li class="clearfix">
                    <div class="fl">题单类型</div>
                    <div class="fr">
                      <span v-if="$route.query.educational != null">校区题单</span>
                      <span v-else>平台题单</span>

                    </div>
                  </li>
                  <li>
                    <!-- <el-button type="primary" @click="drawer = true" round style="width:100%">编辑题单简介</el-button> -->
                  </li>

                </ul>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="题目列表" name="second">
          <div>
            <el-button type="primary" icon="el-icon-plus" @click="addList" size="mini">添加问题</el-button>
            <el-button type="primary" icon="el-icon-delete" @click="dels" size="mini">批量删除</el-button>
            <el-button type="primary" @click="changeSoltNum" size="mini">题目排序</el-button>
            <el-button v-if="isShowSoltNum" type="primary" @click="submitSoltNum" size="mini">确认</el-button>

          </div>
          <el-table v-if="isShowTable" :data="tableData" size="mini" stripe style="width: 100%;margin-top:20px"
            :header-cell-style="{ background: '#f5f7fa' }" @selection-change="handleSelectionChange1">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column type="index" label="序号">
            </el-table-column>
            <el-table-column prop="code" label="题号">
              <template slot-scope="scope">
                <span>
                  <span>{{ scope.row.problemInfo.code }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题">
              <template slot-scope="scope">
                <span>
                  <span>{{ scope.row.problemInfo.title }}</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="标签">
              <template slot-scope="scope">
                <span v-for="item in scope.row.problemInfo.problemTagArr" :key="item.id">
                  {{ item.tagInfo.title }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="del(scope.row.problemInfo)">移除</el-button>
              </template>
            </el-table-column>

          </el-table>
          <div v-if="isShowTable" style="margin: 20px; text-align: right">
            <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size"
              layout="total, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
          <div v-if="isShowSoltNum" class="TableSolt">
            <el-table row-key="id" :data="tableDataSolt" tooltip-effect="dark" size="mini" stripe style="width: 100%;"
              :header-cell-style="{ color: '#909399', background: '#f5f7fa' }" @selection-change="handleSelectionChange1">


              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column type="index" label="序号">
              </el-table-column>
              <el-table-column prop="code" label="题号">
                <template slot-scope="scope">
                  <span>
                    <span>{{ scope.row.problemInfo.code }}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="title" label="标题">
                <template slot-scope="scope">
                  <span>
                    <span>{{ scope.row.problemInfo.title }}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="标签">
                <template slot-scope="scope">
                  <span v-for="item in scope.row.problemInfo.problemTagArr" :key="item.id">
                    {{ item.tagInfo.title }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column prop="" label="操作" width="100">
                <template slot-scope="">
                  <i class="el-icon-rank" style="margin-left:20px; cursor: pointer;"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <el-drawer title="提单简介" style="border-color:transparent" size="50%" :visible.sync="drawer" direction="rtl">
      <Tinymce v-model="content"></Tinymce>
    </el-drawer> -->
    <el-dialog title="添加问题" :visible.sync="dialogVisible" width="80%">
      <el-form ref="form" :model="form" :inline="true" size="mini">
        <el-form-item label="标题">
          <el-input v-model="form.title" clearable placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="编号">
          <el-input v-model="form.code" clearable placeholder="请输入编号"></el-input>
        </el-form-item>
        <el-form-item label="按知识点筛选">
          <el-cascader @change="changeKonw" style="width: 230px;" v-model="form.Know" :props="Konwprops"
            :options="KnowledgeList" collapse-tags clearable></el-cascader>
        </el-form-item>
        <el-form-item label="按难度筛选">
          <el-select style="width: 230px;" multiple collapse-tags v-model="form.conditions" placeholder="请选择" clearable>
            <el-option v-for="item in conditionList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按来源筛选">
          <el-select style="width: 230px;" multiple collapse-tags v-model="form.source" placeholder="请选择" clearable>
            <el-option v-for="item in sourceList" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="adminGetOjProblemListForProblemList" icon="el-icon-search"
            size="mini">查询</el-button>

        </el-form-item>
      </el-form>
      <el-table ref="ListTable" :data="tableData1" :row-key="(row) => { return row.id }" stripe
        style="width: 100%;margin-top:20px" :header-cell-style="{ background: '#f5f7fa' }"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" :reserve-selection="true">
        </el-table-column>
        <el-table-column prop="code" label="题号">
        </el-table-column>
        <el-table-column prop="title" label="标题">
        </el-table-column>
        <el-table-column label="标签">
          <template slot-scope="scope">
            <span v-for="item in scope.row.problemTagArr" :key="item.id">
              {{ item.tagInfo.title }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="difficultyTitle" label="难度">
        </el-table-column>
        <el-table-column prop="sourceTitle" label="来源">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent1" :current-page="page_no1" :page-size="page_size1"
          layout="total, prev, pager, next, jumper" :total="total1">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Tinymce from "@/components/Tinymce";
import Sortable from 'sortablejs';

import {
  adminGetOjProblemListForProblemList,
  adminAddProblemForProblemList,
  adminGetProblemForProblemList,
  adminDeleteProblemForProblemList,
  adminGetProblemForProblemListSort,
  getOjProblemDifficultyList,//按难度筛选
  getOjProblemTagGroupList,//知识点
  getOjProblemSourceList,//来源
  tchUpdateProblemSortOfPorblemList
}
  from "@/api/adminOj.js";
// import {
//   getOjProblemDifficultyList,//按难度筛选
//   getOjProblemTagGroupList,//知识点
//   getOjProblemSourceList,//来源
//   tchUpdateProblemSortOfPorblemList

// }
//   from "@/api/educational.js"

export default {
  components: {
    // Tinymce,
  },
  data() {
    return {
      soltIds: [],

      //题目排序
      tableDataSolt: [],
      //题单
      isShowSoltNum: false,
      isShowTable: true,
      //来源
      sourceList: [],
      //知识点
      KnowledgeList: [],
      Konwprops: {
        value: 'id',
        label: 'title',
        children: 'tagArrInfo',
        multiple: true
      },
      //难度
      conditionList: [],
      form: {
        conditions: [],
        Know: [],
        source: [],
        Know1: [],
      },
      dialogVisible: false,
      problemlist_id: '',

      content: '',
      drawer: false,
      page_no: 1,
      page_size: 20,
      total: 20,
      page_no1: 1,
      page_size1: 20,
      total1: 20,
      activeName: 'first',
      tableData: [],
      tableData1: [],
      multipleSelection: [],
      multipleSelection1: []

    }
  },
  created() {
    this.problemlist_id = this.$route.query.problemlist_id
  },
  mounted() {
    this.adminGetProblemForProblemList()
    this.getOjProblemDifficultyList()//按难度筛选
    this.getOjProblemTagGroupList()//知识点
    this.getOjProblemSourceList()//来源

  },
  methods: {

    // 行拖拽
    rowDrop() {

      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector('.TableSolt .el-table__body-wrapper tbody');
      const that = this;
      console.log(that.tableDataSolt, 4547878)

      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: "ghostClass", //设置拖拽停靠样式类名
        chosenClass: "chosenClass", //设置选中样式类名
        handle: '.el-icon-rank',
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log('拖动了行，当前序号：' + newIndex);
          const currentRow = that.tableDataSolt.splice(oldIndex, 1)[0];
          that.tableDataSolt.splice(newIndex, 0, currentRow);
          console.log(that.tableDataSolt, 4578)
        }
      })
    },
    //排序
    adminGetProblemForProblemListSort() {
      adminGetProblemForProblemListSort({
        problemlist_id: this.problemlist_id,
      }).then((res) => {
        console.log(res)
        this.tableDataSolt = res.problemListRelationList
      })
    },
    //排序
    changeSoltNum() {
      this.adminGetProblemForProblemListSort()

      console.log(12121);
      this.isShowTable = false
      this.isShowSoltNum = true
      this.$nextTick(() => {
        this.rowDrop();

      })
    },
    submitSoltNum() {
      this.soltIds = []
      this.tableDataSolt.map((item) => {
        this.soltIds.push(item.id)
      })
      console.log(this.soltIds, 7777888);
      tchUpdateProblemSortOfPorblemList({
        problemListRelationArr: JSON.stringify(this.soltIds)
      }).then((res) => {
        console.log(res);
        this.adminGetProblemForProblemList()

        this.$message.success('修改成功')
      })
      this.isShowTable = true
      this.isShowSoltNum = false
    },

    //查询
    //难度
    getOjProblemDifficultyList() {
      getOjProblemDifficultyList({}).then((res) => {
        this.conditionList = res.ojProblemDifficultyList
      })
    },
    //知识点
    getOjProblemTagGroupList() {
      getOjProblemTagGroupList().then((res) => {
        this.KnowledgeList = res.ojProblemTagGroupList
        console.log(res, 5653232);
      })
    },
    changeKonw(val) {
      this.form.Know1 = []
      val.map((item) => {
        this.form.Know1.push(item[1])
      })
      console.log(this.form.Know1, 452121);
    },
    //来源
    // sourceList
    getOjProblemSourceList() {
      getOjProblemSourceList({}).then((res) => {
        console.log(res)
        this.sourceList = res.ojProblemSourceList
      })
    },
    handleSelectionChange1(val) {
      console.log(val)
      let arr1 = []
      this.multipleSelection1 = [];
      for (let k = 0; k < val.length; k++) {
        arr1.push(val[k].id);
        console.log(arr1)
        this.multipleSelection1 = arr1
      }
      console.log(this.multipleSelection1)


    },
    dels() {
      if (this.multipleSelection1.length === 0) {
        this.$message.warning('请选中再进行删除!')
        return false
      }
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteProblemForProblemList({
          problemlist_id: this.problemlist_id,
          problemIds: JSON.stringify(this.multipleSelection1)
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.adminGetProblemForProblemList()

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    //删除
    del(row) {
      console.log(row.id)
      let ids = []
      ids.push(row.id)
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteProblemForProblemList({
          problemlist_id: this.problemlist_id,
          problemIds: JSON.stringify(ids)
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.adminGetProblemForProblemList()

        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //获取题单列表
    adminGetProblemForProblemList() {
      adminGetProblemForProblemList({
        problemlist_id: this.problemlist_id,
        page_no: this.page_no,
        page_size: this.page_size
      }).then((res) => {
        console.log(res)
        this.tableData = res.problemListRelationList
        this.total = res.total

      })
    },
    submit() {
      adminAddProblemForProblemList({
        problemlist_id: this.problemlist_id,
        problemIds: JSON.stringify(this.multipleSelection)
      }).then((res) => {
        console.log(res)
        this.$message.success('添加成功!')
        this.dialogVisible = false
        this.adminGetProblemForProblemList()


      })

    },
    addList() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.ListTable.clearSelection()
      })
      this.page_no1 = 1
      this.adminGetOjProblemListForProblemList()

    },
    adminGetOjProblemListForProblemList() {
      adminGetOjProblemListForProblemList({
        difficultyIdArr: JSON.stringify(this.form.conditions),
        tagIdArr: JSON.stringify(this.form.Know1),
        sourceIdArr: JSON.stringify(this.form.source),
        title_code: this.form.title_code,
        title: this.form.title,
        code: this.form.code,
        problemlist_id: this.problemlist_id,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log(res)
        this.tableData1 = res.ojProblemList
        this.total1 = res.total
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      let arr = []
      this.multipleSelection = [];
      for (let k = 0; k < val.length; k++) {
        arr.push(val[k].id);
        console.log(arr)
        this.multipleSelection = arr
      }
      console.log(this.multipleSelection)


    },
    goback() {
      this.$router.go(-1)
    },
    handleCurrent(val) {
      this.page_no = val
    },
    handleCurrent1(val) {
      this.page_no1 = val
      this.adminGetOjProblemListForProblemList()
    },
  }

}
</script>

<style lang="scss" scoped>
.subjectDetails {
  height: 100%;
  width: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  cursor: pointer;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.main {
  margin: 10px;
  background: 10px;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.briefIntroduction_right {
  padding: 20px;
  padding-top: 0px;
  background: #f9f9f9;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #ccc;
}

.briefIntroduction_right li {
  margin-top: 20px;
  font-size: 16px;
  font-weight: 500;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

::v-deep .el-drawer__header> :first-child {
  outline: none;
}
</style>